/** 获取视图设计时配置 */
export const GetDesignerViewSetting = '/v1/view/designer/setting';

/** 获取视图配置标签页 */
export const GetViewSettingPageList = '/v1/view/page/header';

/** 获取视图运行时配置 */
export const GetViewSetting = '/v1/view/setting';

/** 更新视图设计配置 */
export const UpdateViewSetting = '/v1/view/designer/setting';

/** 获取视图偏好配置 */
export const GetViewPreference = '/v1/preference/view';

/** 新增视图偏好配置 */
export const AddViewPreference = '/v1/preference/addView';

/** 更新视图偏好配置 */
export const UpdateViewPreference = '/v1/preference/updateView';

/** 删除视图偏好配置 */
export const RemoveViewPreference = '/v1/preference/deleteView';

/** 排序视图偏好配置 */
export const SortViewPreference = '/v1/preference/view/sort';

/** 加载视图配置 */
export const LoadViewDesigner = '/v1/view/designer/load';

/** 保存视图配置 */
export const SaveViewDesigner = '/v1/view/designer/save';

/**
 * 单独保存列表视图按钮
 */
export const SaveViewDesignerActions = '/v1/view/designer/smartactions/save';

/** 获取层级视图是否超出阈值 */
export const CheckHierarchyLimit = '/v1/formdesign/checktreestructurefield';

/** 获取列表视图默认显示列 */
export const LoadListViewDefaultColumns = '/v1/view/designer/column/default';

/** 获取视图按钮 */
export const LoadViewActionList = '/v1/formdesign/action';
